import store from '@/store/store'

/**
 * 'LoginForm.guards'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  loadCatalogs (to, from, next) {
    let promises = []
    promises.push(store.dispatch('app/profile'))
    return Promise.all(promises)
      .then(next)
      .catch(next)
  }
}



// WEBPACK FOOTER //
// ./src/guards/app.guards.js